import { InitialStateType, INITIAL_STATE } from '.';
import { RegisterContextActions } from './RegisterContextActions';

export interface IDispatchAction {
  type: RegisterContextActions;
  payload?: RegisterContextActions;
}

export const EventReducer = (
  state = INITIAL_STATE,
  action: any
): InitialStateType => {
  const { type, payload } = action;

  switch (type) {
    case RegisterContextActions.SET_STEP_COMPLETED:
      return { ...state, completed: [...payload] };
    case RegisterContextActions.SET_STEP_ID:
      return { ...state, stepId: payload };
    case RegisterContextActions.SET_STATUS:
      return { ...state, status: payload };
    case RegisterContextActions.SET_INITIAL_STATUS:
      return { ...state, initialStatus: payload };
    case RegisterContextActions.SET_EVENT_STATUS:
      return { ...state, eventStatus: payload };
    case RegisterContextActions.SET_MAXIMUM_QUANTITY_ASSOCIATES:
      return { ...state, maximumQuantityAssociates: payload };
    case RegisterContextActions.SET_SHOW_ALERT:
      return { ...state, showAlert: payload };
    case RegisterContextActions.SET_TO_PAGE:
      return { ...state, toPage: payload };

    // Data Step
    case RegisterContextActions.DATA_FILTER_SET:
      return {
        ...state,
        data: { ...state.data, campos: { ...state.data.campos, ...payload } },
      };
    case RegisterContextActions.DATA_FILTER_SET_OLD:
      return {
        ...state,
        dataOld: {
          ...state.dataOld,
          campos: { ...state.dataOld.campos, ...payload },
        },
      };

    case RegisterContextActions.DATA_ASSEMBLY_COOPERATIVE:
      return {
        ...state,
        data: { ...state.data, cooperativeOptions: payload },
      };
    case RegisterContextActions.DATA_ASSEMBLY_TYPE:
      return { ...state, data: { ...state.data, type: payload } };
    case RegisterContextActions.DATA_ASSEMBLY_MODALITY:
      return { ...state, data: { ...state.data, modalities: payload } };
    case RegisterContextActions.DATA_ASSEMBLY_LINK:
      return { ...state, data: { ...state.data, link: payload } };
    case RegisterContextActions.DATA_ASSEMBLY_TYPE_LOAD:
      return { ...state, data: { ...state.data, tiposLoading: payload } };
    case RegisterContextActions.DATA_ASSEMBLY_COOPERATIVE_LOAD:
      return {
        ...state,
        data: { ...state.data, cooperativeLoading: payload },
      };
    case RegisterContextActions.DATA_ASSEMBLY_MODALITY_LOAD:
      return { ...state, data: { ...state.data, modalitiesLoading: payload } };
    case RegisterContextActions.DATA_ASSEMBLY_LINK_LOAD:
      return { ...state, data: { ...state.data, linkLoading: payload } };

    // Entity Step
    case RegisterContextActions.ENTITIES_FILTER_SET:
      return {
        ...state,
        entities: {
          ...state.entities,
          inputs: { ...state.entities.inputs, ...payload },
        },
      };
    case RegisterContextActions.ENTITIES_AGENCY:
      return {
        ...state,
        entities: { ...state.entities, agencyOptions: payload },
      };
    case RegisterContextActions.ENTITIES_NUCLEOU:
      return {
        ...state,
        entities: { ...state.entities, nucleouOptions: payload },
      };
    case RegisterContextActions.ENTITIES_TABLE_DATA:
      return {
        ...state,
        entities: {
          ...state.entities,
          tableData: payload.sort(
            (a: { agn: { value: string } }, b: { agn: { value: string } }) =>
              a.agn?.value! < b.agn?.value! ? -1 : 1
          ),
        },
      };
    case RegisterContextActions.ENTITIES_TABLE_DATA_OLD:
      return {
        ...state,
        entitiesOld: {
          ...state.entitiesOld,
          tableData: payload.sort(
            (a: { agn: { value: string } }, b: { agn: { value: string } }) =>
              a.agn?.value! < b.agn?.value! ? -1 : 1
          ),
        },
      };
    case RegisterContextActions.ENTITIES_ALL_NUCLEOU_PER_AGENCY:
      return {
        ...state,
        entities: { ...state.entities, allNucPerAgency: payload },
      };
    case RegisterContextActions.ENTITIES_AGENCY_LOAD:
      return {
        ...state,
        entities: { ...state.entities, agencyLoading: payload },
      };
    case RegisterContextActions.ENTITIES_NUCLEOU_LOAD:
      return {
        ...state,
        entities: { ...state.entities, nucleouLoading: payload },
      };

    // Local Step

    case RegisterContextActions.LOCAL_FILTER_SET:
      return {
        ...state,
        local: {
          ...state.local,
          inputs: { ...state.local.inputs, ...payload },
        },
      };
    case RegisterContextActions.LOCAL_FILTER_SET_OLD:
      return {
        ...state,
        localOld: {
          ...state.localOld,
          inputs: { ...state.localOld.inputs, ...payload },
        },
      };
    case RegisterContextActions.LOCAL_STATES_OPTIONS:
      return { ...state, local: { ...state.local, stateOptions: payload } };
    case RegisterContextActions.LOCAL_CITIES_OPTIONS:
      return { ...state, local: { ...state.local, citiesOptions: payload } };
    case RegisterContextActions.LOCAL_LOAD:
      return { ...state, local: { ...state.local, loadData: payload } };

    // Staves Step
    case RegisterContextActions.STAVES_TABLE_DATA:
      return { ...state, staves: { ...state.staves, agendas: payload } };
    case RegisterContextActions.STAVES_INITIAL_TABLE_DATA:
      return { ...state, staves: { ...state.staves, agendasOld: payload } };

    // Survey Step
    case RegisterContextActions.SURVEY_FILTER_SET:
      return { ...state, survey: { ...state.survey, ...payload } };
    case RegisterContextActions.SURVEY_TEMPLATES:
      return { ...state, survey: { ...state.survey, templates: payload } };
    case RegisterContextActions.SURVEY_TEMPLATES_LOAD:
      return { ...state, survey: { ...state.survey, templateLoad: payload } };
    case RegisterContextActions.SURVEY_FILTER_SET_OLD:
      return { ...state, survey: { ...state.survey, enabledOld: payload } };

    // Attachments Step

    case RegisterContextActions.ATTACHMENT_TABLE_DATA:
      return {
        ...state,
        attachments: { ...state.attachments, files: payload },
      };

    default:
      throw new Error();
  }
};
